<template>
  <el-dialog :visible.sync="dialogVisible" :title="$t('task.logTitle') + ' - ' + taskName" width="800px"
    @close="handleClose" :close-on-click-modal="false">
    <el-table v-loading="loading" :data="tableData" border style="width: 100%">
      <el-table-column prop="startTime" :label="$t('task.log.startTime')" width="160" align="center" />
      <el-table-column prop="endTime" :label="$t('task.log.endTime')" width="160" align="center" />
      <el-table-column :label="$t('task.log.duration')" width="120" align="center">
        <template slot-scope="scope">
          {{ formatDuration(scope.row.duration) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('task.log.state')" width="80" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.state === 'S' ? 'success' : 'danger'" size="small">
            {{ scope.row.state === 'S' ? $t('task.log.success') : $t('task.log.fail') }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="result" :label="$t('task.log.result')" show-overflow-tooltip />
    </el-table>
    <el-pagination :current-page.sync="page.current" :page-sizes="[10, 20, 50]" :page-size="page.size"
      :total="page.total" layout="total, sizes, prev, pager, next" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" style="margin-top: 15px; text-align: right;" />
  </el-dialog>
</template>

<script>
import { getTaskLogList } from '@/api/dev/taskApi'

export default {
  name: 'TaskLogDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    taskId: {
      type: String,
      default: ''
    },
    taskName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible(val) {
      if (val && this.taskId) {
        this.page.current = 1
        this.getList()
      }
    }
  },
  methods: {
    async getList() {
      try {
        this.loading = true
        const params = {
          taskId: this.taskId,
          page: this.page.current,
          row: this.page.size
        }
        const { data, total } = await getTaskLogList(params)
        this.tableData = data
        this.page.total = total
      } catch (error) {
        this.$message.error(this.$t('task.log.fetchError'))
      } finally {
        this.loading = false
      }
    },
    formatDuration(ms) {
      if (!ms && ms !== 0) return '-'
      if (ms < 1000) return ms + 'ms'
      const seconds = Math.floor(ms / 1000)
      const remainMs = ms % 1000
      if (seconds < 60) return seconds + 's ' + remainMs + 'ms'
      const minutes = Math.floor(seconds / 60)
      const remainSeconds = seconds % 60
      return minutes + 'm ' + remainSeconds + 's'
    },
    handleSizeChange(val) {
      this.page.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.getList()
    },
    handleClose() {
      this.tableData = []
      this.page = { current: 1, size: 10, total: 0 }
    }
  }
}
</script>
